import type { GuideTourStep } from "../../GuideTour/types";

/** Selectors match ids on `CreateWhitelabelGuideShell`. */
export const WL_CREATE_TOUR_STEPS: GuideTourStep[] = [
  {
    id: "brand-name",
    selector: "#wl-tour-brand-name",
    content: "Enter your brand name here",
  },
  {
    id: "subdomain",
    selector: "#wl-tour-subdomain-row",
    content: "Choose your unique web address",
  },
  {
    id: "logo",
    selector: "#wl-tour-logo-upload",
    content: "Upload your brand logo",
    demoKind: "logoPlaceholder",
  },
  {
    id: "next-branding",
    selector: "#wl-tour-next-branding",
    content: "Continue to the next step when you are ready",
    action: "clickNext",
    advanceWhenFlowIndex: 1,
  },
  {
    id: "skin",
    selector: "#wl-tour-skin",
    content: "Choose a UI skin for your platform",
  },
  {
    id: "theme",
    selector: "#wl-tour-theme",
    content: "Pick a theme color/style",
  },
  {
    id: "products",
    selector: "#wl-tour-products",
    content: "Select the products you want to offer",
  },
  {
    id: "payment",
    selector: "#wl-tour-payment-modes",
    content: "Choose how users will make payments",
  },
  {
    id: "next-setup",
    selector: "#wl-tour-next-setup",
    content: "Continue to package plans",
    action: "clickNext",
    advanceWhenFlowIndex: 2,
  },
  {
    id: "packages",
    selector: "#wl-tour-packages",
    content: "Select a plan to continue",
  },
  {
    id: "next-packages",
    selector: "#wl-tour-next-packages",
    content: "Review your choices before submitting",
    action: "clickNext",
    advanceWhenFlowIndex: 3,
  },
  {
    id: "review",
    selector: "#wl-tour-review",
    content: "Review all your selections carefully",
  },
  {
    id: "submit",
    selector: "#wl-tour-submit",
    content: "Click here to create your brand",
  },
];
